import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getPayments,getInvoices } from "./paymentAPI";

export const fetchPayments = createAsyncThunk(
  "payments/fetchPayments",
  async (dealerId) => {
    return await getPayments(dealerId);
  }
);
export const fetchInvoices = createAsyncThunk(
  "payments/fetchInvoices",
  async (customerId) => {
    return await getInvoices(customerId);
  }
);

const paymentSlice = createSlice({
  name: "payments",
  initialState: {
    payments: [],
    loading: false,
     invoices: [],
    invoiceLoading: false,
  },
  reducers: {
    setInvoices: (state, action) => {
      state.invoices = action.payload || [];
    },
  },

  extraReducers: (builder) => {
    builder
       // payments
      .addCase(fetchPayments.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPayments.fulfilled, (state, action) => {
        state.loading = false;
        state.payments = Array.isArray(action.payload) ? action.payload : [];
      })

      // invoices
      .addCase(fetchInvoices.pending, (state) => {
        state.invoiceLoading = true;
      })
.addCase(fetchInvoices.fulfilled, (state, action) => {
  console.log("========== REDUX ==========");
  console.log("REDUX PAYLOAD 👉", action.payload);

  state.invoiceLoading = false;
  state.invoices = action.payload || [];
})
  },
});

export const { setInvoices } = paymentSlice.actions;

export default paymentSlice.reducer;
